import {
    ONBOARDING_REDIRECT_ON_COMPLETE,
    ONBOARDING_SET_PLAYERID,
    ONBOARDING_POST_UTR_RANGE_SURVEY,
    ONBOARDING_POST_UTR_RANGE_SURVEY_SUCCESS,
    ONBOARDING_POST_UTR_RANGE_SURVEY_FAILURE,
    ONBOARDING_SET_DISABLE_RANGE_SURVEY_SKIP,
    ONBOARDING_SKIP_UTR_RANGE_SURVEY,
    ONBOARDING_SKIP_UTR_RANGE_SURVEY_FAILURE,
    ONBOARDING_SET_SKIP_ONBOARDING_INTRO_POPUP,
    ONBOARDING_SHOW_RANGE_POPUP,
    ONBOARDING_SHOW_PBR_RANGE_POPUP,
    ONBOARDING_GET_RATED_POPUP_DISMISSED,
    ONBOARDING_SET_SHOW_RATING,
    ONBOARDING_SET_SHOW_POWER,
    ONBOARDING_GET_NUO_STATUS,
    ONBOARDING_GET_NUO_STATUS_SUCCESS,
    ONBOARDING_POST_NUO_DATA,
    ONBOARDING_POST_NUO_DATA_FAILURE,
    ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY,
    ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_FAILURE,
    ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_SUCCESS,
} from '../actions/onboarding-actions';

const initialState = {
    utrRangeSurvey: {
        saving: false,
        error: null,
    },
    disableRangeSurveySkip: false,
    skipOnboardingIntroPopup: false,
    showRangePopup: false,
    showPbrRangePopup: false,
    showPowerPopup: false,
    nuo: {
        data: null,
        loading: false,
        error: false,
        showRating: false,
        isFromStep: null,
    },
    pickleballRangeSurvey: {
        success: false,
        error: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ONBOARDING_SET_PLAYERID: {
            return {
                ...state,
                playerId: action.playerId,
            };
        }
        case ONBOARDING_REDIRECT_ON_COMPLETE: {
            return {
                ...state,
                redirectUrl: action.url,
            };
        }
        case ONBOARDING_POST_UTR_RANGE_SURVEY: {
            return {
                ...state,
                utrRangeSurvey: {
                    saving: true,
                    error: null,
                },
            };
        }
        case ONBOARDING_POST_UTR_RANGE_SURVEY_SUCCESS: {
            return {
                ...state,
                utrRangeSurvey: {
                    saving: false,
                    error: null,
                },
            };
        }
        case ONBOARDING_POST_UTR_RANGE_SURVEY_FAILURE: {
            return {
                ...state,
                utrRangeSurvey: {
                    saving: false,
                    error: action.payload,
                },
            };
        }
        case ONBOARDING_SET_DISABLE_RANGE_SURVEY_SKIP: {
            return {
                ...state,
                disableRangeSurveySkip: action.payload,
            };
        }
        case ONBOARDING_SKIP_UTR_RANGE_SURVEY: {
            return {
                ...state,
                utrRangeSurvey: {
                    error: null,
                },
            };
        }
        case ONBOARDING_SKIP_UTR_RANGE_SURVEY_FAILURE: {
            return {
                ...state,
                utrRangeSurvey: {
                    error: action.payload,
                },
            };
        }
        case ONBOARDING_SET_SKIP_ONBOARDING_INTRO_POPUP: {
            return {
                ...state,
                skipOnboardingIntroPopup: action.payload,
            };
        }
        case ONBOARDING_SHOW_RANGE_POPUP: {
            return {
                ...state,
                showRangePopup: action.payload,
            };
        }
        case ONBOARDING_SHOW_PBR_RANGE_POPUP: {
            return {
                ...state,
                showPbrRangePopup: action.payload,
            };
        }
        case ONBOARDING_GET_RATED_POPUP_DISMISSED: {
            return {
                ...state,
                getRatedPopupDismissed: action.payload,
            };
        }
        case ONBOARDING_GET_NUO_STATUS:
        case ONBOARDING_POST_NUO_DATA: {
            return {
                ...state,
                nuo: {
                    ...state.nuo,
                    loading: true,
                    error: false,
                },
            };
        }
        case ONBOARDING_GET_NUO_STATUS_SUCCESS: {
            return {
                ...state,
                nuo: {
                    ...state.nuo,
                    data: action.payload,
                    loading: false,
                    error: false,
                },
            };
        }
        case ONBOARDING_POST_NUO_DATA_FAILURE: {
            return {
                ...state,
                nuo: {
                    ...state.nuo,
                    loading: false,
                    error: true,
                    errorCode: action.payload,
                },
            };
        }
        case ONBOARDING_SET_SHOW_RATING: {
            return {
                ...state,
                nuo: {
                    ...state.nuo,
                    showRating: action.showRating,
                    isFromStep: action.isFromStep,
                },
            };
        }
        case ONBOARDING_SET_SHOW_POWER: {
            return {
                ...state,
                showPowerPopup: action.payload,
            };
        }
        case ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY: {
            return {
                ...state,
                pickleballRangeSurvey: {
                    success: false,
                    error: false,
                },
            };
        }
        case ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_SUCCESS: {
            return {
                ...state,
                pickleballRangeSurvey: {
                    success: true,
                    error: false,
                },
            };
        }
        case ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_FAILURE: {
            return {
                ...state,
                pickleballRangeSurvey: {
                    success: false,
                    error: true,
                },
            };
        }
        default:
            return state;
    }
};
